import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import "@/styles/index.scss"; // global css
import "@/styles/variables.scss";

library.add(fas);
Vue.component("font-awesome-icon", FontAwesomeIcon);

import "@/filter/date.js"; // global filter

Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });


new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
